import { useLocalValue } from "@/hooks/use-local-value";
import { COUNTDOWN_KEY, countdownEnabled } from "@/lib/preferences";

/** Whether this viewer wants the reveal countdown (they can switch it off in Settings). */
export function useCountdownEnabled(): boolean {
  return countdownEnabled(useLocalValue(COUNTDOWN_KEY));
}
